import { enqueueSnackbar } from 'notistack';

const Notification = ({ message, variant = 'success', props }) => enqueueSnackbar(message, { variant, ...props });

export default Notification;
